import { useEffect, useState } from "react";
import { Row, Col, Table, Spinner, Form } from "react-bootstrap";
import { Link } from 'react-router-dom';
import './LicitacoesContratos.css';
import debounce from 'lodash.debounce';
//import CleanPagination from '../Components/CleanPagination';

export default function Contratos() {
    let [licitacoes, setLicitacoes] = useState([]);
    let [loading, setLoading] = useState(true);
    let [page, setPage] = useState(0);

    let [ordenacao, setOrdenacao] = useState({
        campo: "CONTRATO",
        ordem: "DESC"
    });

    let [formData, setFormData] = useState({
        ano: "",
        texto: "",
        tipo: "",
        ordenacao: "CONTRATODESC"
    });

    let years = [];
    let currentYear = new Date().getFullYear();
    
    while (currentYear > 2012) {
        years.push(currentYear);
        currentYear--;
    } 

    const formatDateAsDMY = (dataObject) => {
        if (!dataObject) {
            return "";
        }
        // API sometimes returns a string or null instead of { date: "..." }
        const rawDate = dataObject?.date ?? dataObject;
        const date = new Date(rawDate);
        if (Number.isNaN(date.getTime())) {
            return "";
        }
        const day = date.getDate();
        const month = date.getMonth() + 1; // Adding 1 to get the correct month
        const year = date.getFullYear();
        
        // Padding day and month with leading zeros if necessary
        const formattedDay = day < 10 ? `0${day}` : `${day}`;
        const formattedMonth = month < 10 ? `0${month}` : `${month}`;
      
        // Creating the formatted date string
        const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;
      
        return formattedDate;
    }

    const tipos = ["Concorrência",
        "Convite",
        "Dispensa",
        "Inexigibilidade",
        "Leilão",
        "Pregão Eletrônico",
        "Pregão Presencial",
        "Tomada de Preços"];

    const previousPage = () => {
        setPage(page - 1);
    };

    const nextPage = () => {
        setPage(page + 1);
    };

    const getData = () => {
        setLoading(true);
        fetch(`https://www.alepe.pe.gov.br/contratos/list.php?pagina=${page}&ano=${formData.ano}&texto=${formData.texto}&tipo=${formData.tipo}&ordenacao=${formData.ordenacao}`).then(result => {
            result.json().then((jsonResult) => {
                setLicitacoes(jsonResult.data);
                setLoading(false);
            });
        });
    }

    useEffect(() => {
        getData();
    }, [formData, page]);

    useEffect(() => {
        setFormData({...formData, ordenacao: (ordenacao.campo + ordenacao.ordem)})
    }, [ordenacao]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const debouncedHandleInputChange = debounce(handleInputChange, 500);

    const handleInputChangeOrdenacao = (e) => {
        const { name, value } = e.target;
        setOrdenacao({ ...ordenacao, [name]: value });
    };

    return <Row>
        <Col xs="12">
            <p><small>Você está em <a href="/financas">Prestação de Contas</a> / Contratos</small></p>
        </Col>
        <Col xs="12" style={{height: '25px'}}>
            <p>Filtros de Busca</p>
        </Col>
        <Col xs="12" className="mb-2">
            <Form onSubmit={(e) => {
                    e.preventDefault(); // Prevent the default form submission
                    //getData(); // Call your getData function here
                }}>
                <Row>
                    <Col xs="2">
                        <Form.Group controlId="ano">
                            <Form.Control
                                as="select"
                                name="ano"
                                onChange={handleInputChange}
                                style={{ height: '38px' }}
                            >
                                <option value="">Ano</option>
                                { years.map((year) => { return <option key={year} value={year}>{year}</option>})}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs="7">
                        <Form.Group controlId="texto">
                            <Form.Control
                                type="text"
                                name="texto"
                                placeholder="Busca por texto"
                                onChange={debouncedHandleInputChange}
                                style={{ height: '38px' }}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs="3">
                        <Form.Group controlId="tipo">
                            <Form.Control
                                    as="select"
                                    name="tipo"
                                    onChange={handleInputChange}
                                    style={{ height: '38px' }}
                                >
                                    <option value="">Tipo</option>
                                    { tipos.map((tipo) => { return <option key={tipo} value={tipo}>{tipo}</option>})}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    {/*<Col xs="2">
                        <Button className="button" type="submit">
                            Buscar
                        </Button>
                    </Col>*/}
                </Row>
            </Form>
        </Col>
        <Col xs="12" style={{height: '25px'}}>
            <p>Ordenar por</p>
        </Col>
        <Col xs="12" className="mb-3">
            <Form onSubmit={(e) => {
                    e.preventDefault(); // Prevent the default form submission
                    //setOrdenacao(); // Call your getData function here
                }}>
                <Row>
                    <Col xs="3">
                        <Form.Group controlId="campo">
                            <Form.Control
                                as="select"
                                name="campo"
                                onChange={handleInputChangeOrdenacao}
                                style={{ height: '38px' }}
                            >
                                <option value="CONTRATO">Contrato</option>
                                <option value="TIPO">Tipo</option>
                                <option value="OBJETO">Objeto</option>
                                <option value="VALOR">Valor</option>
                                <option value="DATA">Data</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xs="3">
                        <Form.Group controlId="ordem">
                            <Form.Control
                                as="select"
                                name="ordem"
                                onChange={handleInputChangeOrdenacao}
                                style={{ height: '38px' }}
                            >
                                <option value="DESC">Decrescente</option>
                                <option value="ASC">Ascendente</option>
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </Col>
        <Col xs="12" className="text-center">
            {loading ? <Spinner/> : null}
        </Col>
        <Col xs="12">
            <Row>
                <Col xs={{spam: 2, offset: 10}} className='mb-2 text-center'>
                    <div>
                        <a href="https://www.alepe.pe.gov.br/contratos/export.php" title="Download em CSV"><img src="/img/download-csv.png" height="16" width="16" alt=""/>CSV</a>
                    </div>
                </Col>
            </Row>
            <div className="table-responsive">
                <Table striped bordered hover>
                    <thead>
                    <tr>
                        <th>Contrato</th>
                        <th>Tipo</th>
                        <th>Objeto</th>
                        <th>Valor</th>
                        <th>Data</th>
                    </tr>
                    </thead>
                    <tbody>
                        { licitacoes?.map((contrato) => {
                            return <tr key={contrato.ID}>
                                <td><Link to={"/financas/contrato/" + contrato.Id} target="_blank">{contrato.NumeroContrato + "/" + contrato.AnoContrato}</Link></td>
                                <td>{contrato.TipoProcesso}</td>
                                <td>{contrato.Objeto}</td>
                                <td>R${Number(contrato.Valor).toFixed(2)}</td>
                                <td>{formatDateAsDMY(contrato.InicioVigencia)}</td>
                            </tr>
                        }) }
                    </tbody>
                </Table>
            </div>
        </Col>
        <Col xs="6" className="text-start">
            {page > 0 ? 
                <a href="#" onClick={(e) => {previousPage();}}>Página Anterior</a>
            : null}
        </Col> 
        <Col xs="6" className="text-end">
            {licitacoes.length == 10 ? 
                <a href="#" onClick={(e) => {nextPage();}}>Próxima Página</a>
            : null}
        </Col> 
        {/*<Col xs="12" className="text-center">
            <CleanPagination
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageSelect}
            />
        </Col>*/}
    </Row>
}
